import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import GroupManagement from './pages/group-management';
import AgencyDashboard from './pages/agency-dashboard';
import Login from './pages/login';
import VisaManagement from './pages/visa-management';
import PilgrimProfile from './pages/pilgrim-profile';
import FinancialManagement from './pages/financial-management';
import PilgrimManagement from './pages/pilgrim-management';
import SuperAdminDashboard from './pages/super-admin-dashboard';
import DocumentManagement from './pages/document-management';
import CommunicationCenter from './pages/communication-center';
import AgencyRegistration from './pages/agency-registration';
import AnalyticsDashboard from './pages/analytics-dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import UserProfileSettings from './pages/user-profile-settings';
import AgencyManagement from './pages/agency-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/agency-registration" element={<AgencyRegistration />} />
        
        <Route path="/agency-dashboard" element={
          <ProtectedRoute>
            <AgencyDashboard />
          </ProtectedRoute>
        } />
        <Route path="/analytics-dashboard" element={
          <ProtectedRoute>
            <AnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/pilgrim-management" element={
          <ProtectedRoute>
            <PilgrimManagement />
          </ProtectedRoute>
        } />
        <Route path="/group-management" element={
          <ProtectedRoute>
            <GroupManagement />
          </ProtectedRoute>
        } />
        <Route path="/visa-management" element={
          <ProtectedRoute>
            <VisaManagement />
          </ProtectedRoute>
        } />
        <Route path="/financial-management" element={
          <ProtectedRoute>
            <FinancialManagement />
          </ProtectedRoute>
        } />
        <Route path="/document-management" element={
          <ProtectedRoute>
            <DocumentManagement />
          </ProtectedRoute>
        } />
        <Route path="/communication-center" element={
          <ProtectedRoute>
            <CommunicationCenter />
          </ProtectedRoute>
        } />
        <Route path="/pilgrim-profile" element={
          <ProtectedRoute>
            <PilgrimProfile />
          </ProtectedRoute>
        } />
        <Route path="/super-admin-dashboard" element={
          <ProtectedRoute>
            <SuperAdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/agency-management" element={
          <ProtectedRoute>
            <AgencyManagement />
          </ProtectedRoute>
        } />
        <Route path="/user-profile-settings" element={
          <ProtectedRoute>
            <UserProfileSettings />
          </ProtectedRoute>
        } />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
